import React from "react";
import { Link as MuiLink } from "@mui/material";
import PropTypes from "prop-types";

Link.propTypes = {
  item: PropTypes.object.isRequired,
  action: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default function Link(props) {
  const { item, action, onClick, disabled = false } = props;
  return (
    <MuiLink href="#" disabled={disabled} onClick={(e) => onClick(e, action)}>
      {item.label}
    </MuiLink>
  );
}
